<template>

  <div class="header-bar">
    <div class="top-menu-container">
      <div class="top-menu-wrap fourth">
        <div class="secondary-menu more-arrow-down">
          <div class="menu-items mCustomScrollbar _mCS_1">
            <div id="mCSB_1" class="mCustomScrollBox mCS-light mCSB_horizontal mCSB_inside" style="max-height: 35.0694px;" tabindex="0">
              
              <div id="mCSB_1_container" class="mCSB_container mCS_x_hidden mCS_no_scrollbar_x" style="position: relative; top: 0px; left: 0px; width: 100%;" dir="ltr">
                <div class="menu-item menu-item-type-post_type menu-item-object-page" v-for="tab in tabs">
                  <!--<a :href="tab.hash" :title="tab.name">
                    {{ tab.name }}
                  </a>-->
                  <router-link :to="{ name : tab.route , params : { slug : tab.hash , num_volume : tab.params_id } }">
                    {{ tab.name }}
                  </router-link>
                </div>
                
              </div>

              <div id="mCSB_1_scrollbar_horizontal" class="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_horizontal" style="display: none;">
                <a href="#" class="mCSB_buttonLeft"></a>
                <div class="mCSB_draggerContainer">
                  <div id="mCSB_1_dragger_horizontal" class="mCSB_dragger" style="position: absolute; min-width: 30px; width: 0px; left: 0px;">
                    <div class="mCSB_dragger_bar"></div>
                  </div>
                  <div class="mCSB_draggerRail"></div>
                </div>
                <a href="#" class="mCSB_buttonRight"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Tabs', 
  props : {
    tabs : { type : Array }
  },
  components : {
  },
  data () {
    return {

    }
  } ,
  mounted(){
  }
}

</script>

<style lang="scss">

/* specific inclusion of tabs inside pages */
main{
  .header-bar{
    top: 170px !important ;
    .top-menu-container .menu-item a.is-active.router-link-active{
      color: #2B3256 !important;
      border-bottom: 2px solid #2B3256!important;
    }
  }
}

/*.top-menu-container .secondary-menu {
    position: relative;
    padding: 20px 0 ;
}

.top-menu-container .secondary-menu .menu-items {
    display: -ms-flex;
    display: flex;
    -ms-align-items: center;
    align-items: center;
    flex-direction: row;
}

.top-menu-container .secondary-menu .mCSB_container {
    margin-bottom: 0;
}

.top-menu-container .secondary-menu .mCSB_container .menu-item {
    margin-left: 30px;
}

.top-menu-container .secondary-menu .mCSB_container .menu-item:first-child {
    margin-left: 0;
}

.top-menu-container .menu-items .menu-item:not(.menu-home) {
    margin-left: 30px;
}

.top-menu-container .secondary-menu .mCSB_draggerContainer {
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
}

.top-menu-container .secondary-menu .mCSB_scrollTools {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    min-height: 30px;
    pointer-events: none;
}

.top-menu-container .secondary-menu .mCSB_buttonLeft,
.top-menu-container .secondary-menu .mCSB_buttonRight {
    pointer-events: all;
    width: 30px;
    height: 30px;
    opacity: 1;
    display: inline-block;
    background-size: 16px;
}

.top-menu-container .secondary-menu .mCSB_scrollTools:before,
.top-menu-container .secondary-menu .mCSB_scrollTools:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    opacity: 0.8;
    width: 45px;
    z-index: -1;
}

.top-menu-container .secondary-menu .mCSB_scrollTools.left-arrow-hidden:before {
    opacity: 0;
    visibility: hidden;
}
.top-menu-container .secondary-menu .mCSB_scrollTools.right-arrow-hidden:after {
    opacity: 0;
    visibility: hidden;
}


.top-menu-container .secondary-menu .mCSB_scrollTools:before {
    left: 0;
    background: linear-gradient(to right, rgba(255,255,255,1) 85%,rgba(255,255,255,0) 100%);
}

.top-menu-container .secondary-menu .mCSB_scrollTools:after {
    right: 0;
    background: linear-gradient(to left, rgba(255,255,255,1) 85%,rgba(255,255,255,0) 100%);
}

.top-menu-container .secondary-menu .mCSB_buttonLeft {
    background-size: 16px;
}


.top-menu-container .secondary-menu .mCustomScrollBox {
    width: 100%;
}
.top-menu-container .secondary-menu .mCSB_container {
    display: flex;
}

.top-menu-wrap .menu-item > a {
    padding: 5px;
    font-family: 'Object Sans',sans-serif;
    font-size: 16px;
    line-height: 16px;
    font-weight: bold;
    color: #3c3c3c;
    letter-spacing: 1.44px;
    text-transform: uppercase;
}

.top-menu-wrap .current-menu-item > a {
    border-bottom: 3px solid #1e7fb8;
}


.top-menu-wrap .secondary-menu .menu-item > a {
    font-size: 14px;
    font-weight: 400;
    text-transform: initial;
    letter-spacing: 0.1ch;
    border-bottom: none;
}*/

</style>
